const TELEPHONE_SANITIZER = /[^\d*#+]/g;

export const sanitizeDialNumber = value =>
  String(value || '')
    .replace(TELEPHONE_SANITIZER, '')
    .trim();
